import { ButtonSetListComponent } from './button-set-list';

export const components: any[] = [ButtonSetListComponent];

export * from './button-set-list';
